import React from "react";
import "./personality-two.scss";
import {Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppFooter from "../../../../components/appFooter";


export default function PersonalityTwo(props) {
    return (
        <div className={"mainDiv"}>
            <div className="brand-bg-inverse-color mb-3 fancyFont">
                <div className="container">
                    <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
                        <Link to={"/"} className="navbar-brand">
                            <img src={require("../../../../assets/logo.png")} alt="" width={"140px"}/>
                        </Link>
                    </nav>
                </div>
            </div>
            <div className="container fancyFont">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className="h3 brand-text-color inner-header">Mr. Rubaid Rasheed (Ali) Bhojani</h3>
                    </div>

                    <div className="col-lg-12 mb-3 mr-4 alert alert-secondary" role="alert">
                        <strong>"Do the difficult things while they are easy and do the great things while they are
                            small. <p>A journey of
                                a thousand miles must begin with a single step."</p></strong>
                        <div className="text-center">- Lao Tzu</div>
                    </div>
                </div>
            </div>
            <AppFooter/>
        </div>);
}
